import { SUPER_ADMIN } from '../../../constants/role';
import { PROCEDIMENTO_DIGITACAO_ADMIN } from '../../../constants/modules';
import { hasModuleConfiguration } from '../../../helpers/moduleConfigurationPermission';

/** Escrita: módulo ou role super admin. Leitura é de qualquer autenticado. */
export const podeEditarProcedimentoDigitacao = (authData, moduleConfigurations) =>
  authData?.role === SUPER_ADMIN
  || hasModuleConfiguration(moduleConfigurations, authData, PROCEDIMENTO_DIGITACAO_ADMIN);
